import { couponVoucherType, couponVoucherTypeOptions, couponVoucherTypeLabels } from './enums'
import api from './api'
import { debounce } from 'vue-debounce';
import CouponVoucherIssueManager from '@/views/couponVoucherMngt/CouponVoucherIssueManager'
const defaultForm = {
    type: couponVoucherType.Coupon,
    subType: null,
    name: 'name',
    description: 'description',
    bonusAsPercent: false,
    bonusAmount: 0.0,
    price: 0.0,
    referenceType: null,
    referenceId: null,
    usageCountAllowed: 1,
    hasValidity: false,
    validity: null,
    validityYears: 0,
    validityMonths: 3,
    validityDays: 0,
    validityHours: 0,
    validityMinutes: 0,
    validitySeconds: 0,
    isActive: false
}

export default {
    name: 'CouponVoucherProgramManager',
    props: { data: Array },
    components: {
        CouponVoucherIssueManager
    },
    data() {
        return {
            isLoading: false,
            couponVoucherType,
            couponVoucherTypeOptions,
            couponVoucherTypeLabels,
            dialog: false,
            isEdit: false,
            subTypes: [],
            surveys: [],
            form: defaultForm,
            items: [],
            search: '',
            pagination: {
                pageIndex: 1,
                pageSize: 20,
                orderBy: 'Id',
                DirectionSort: 'desc'
            },
            totalRows: 0,
            isShowDetail: false,
            detailItem: null,
            debounceFnc: null,
        }
    },
    computed: {
        filteredPrograms() {
            return (this.data || []).filter((x) => !this.search || (x.name || '').toLowerCase().includes(this.search.toLowerCase()))
        },
        currentSubType() {
            if (this.form.subType == null) return null
            const matchSubType = this.subTypes.find((x) => x.id === this.form.subType)
            return matchSubType
        },
        subTypeMap() {
            return this.subTypes.reduce((acc, item) => {
                acc[item.id] = item
                return acc
            }, {})
        }
    },
    mounted() {
        this.getCouponSubTypes()
        this.getSurveys()
        this.getItems();
        this.debounceFnc = debounce(() => {
            this.pagination.pageIndex = 1
            this.getItems();
        }, 500);
    },
    methods: {
        async getItems() {
            this.isLoading = true
            const response = await api.getItems({ ...this.pagination, querySearch: this.search })
            const isSuceed = response.data.result === 0
            if (isSuceed) {
                this.items = response.data.data.items
                this.totalRows = response.data.data.totalRows
            }
            this.isLoading = false
        },
        refresh() {
            this.pagination.pageIndex = 1
            this.getItems()
        },
        onPageChange(page) {
            this.pagination.pageIndex = page
            this.getItems()
        },
        async onTypeChange() {
            await this.getCouponSubTypes();
            this.onSubTypeChange();
        },
        async getCouponSubTypes() {
            const response = await api.getCouponSubTypes(this.form.type || couponVoucherType.Coupon)
            const isSuceed = response.data.result === 0
            if (isSuceed) {
                console.log('subTypes', response.data.data);
                this.subTypes = response.data.data
                if(this.form.subType == null) this.form.subType = response.data.data[0].id
            }
        },
        async getSurveys() {
            const response = await api.getSurveys()
            const isSuceed = response.data.result === 0
            if (isSuceed) {
                this.surveys = response.data.data
                this.onSubTypeChange()
            }
        },
        onSubTypeChange() {
            if (this.currentSubType && this.currentSubType.refType === 'SURVEY') {
                this.form.referenceId = this.surveys[0].id.toString();
            } else {
                this.form.referenceId = null
            }
        },
        issue(row) {},
        openDialog(row) {
            if (row) {
                this.isEdit = true;
                let units = null;
                console.log('row', row);  
                if(row.validityInSecs){
                    let seconds = Math.floor(row.validityInSecs);
                    units = {
                        year: Math.floor(seconds / (365 * 24 * 60 * 60))
                    }
                    seconds %= 365 * 24 * 60 * 60;

                    units.month = Math.floor(seconds / (30 * 24 * 60 * 60));
                    seconds %= 30 * 24 * 60 * 60;

                    units.day = Math.floor(seconds / (24 * 60 * 60));
                    seconds %= 24 * 60 * 60;

                    units.hour = Math.floor(seconds / (60 * 60));
                    seconds %= 60 * 60;

                    units.minute = Math.floor(seconds / 60);
                    seconds %= 60;

                    units.second = seconds;
                }   
                console.log('units', units);             
                this.form = {
                    ...row,
                    hasValidity: units != null ? true : false,
                    validityYears: units != null ? units.year : 0,
                    validityMonths: units != null ? units.month : 0,
                    validityDays: units != null ? units.day : 0,
                    validityHours: units != null ? units.hour : 0,
                    validityMinutes: units != null ? units.minute : 0,
                    validitySeconds: units != null ? units.second : 0
                }
            } else {
                this.isEdit = false;
                this.form = {
                    ...defaultForm,
                    subType: this.subTypes[0].id
                }
            }
            this.getCouponSubTypes();
            this.dialog = true
        },
        save() {
            this.$emit('save', this.form)
            this.dialog = false
        },
        showDetail(item){
            this.detailItem = item;
            this.isShowDetail = true;
        },
        closeDetail(){
            this.isShowDetail = false;
            this.detailItem = null;
        }
    }
}
